import gql from 'graphql-tag';

const UPDATE_MAIL_REPORT = gql`
  mutation updateMailReport($input: MailReportInput) {
    updateMailReport(input: $input) {
      internalCode
      message
    }
  }
`;

export default UPDATE_MAIL_REPORT;